/**
 * CMCD object header name.
 *
 *
 * @beta
 */
export const CMCD_OBJECT = 'CMCD-Object'
